import { render, staticRenderFns } from "./AgregarArchivoCuentaCobro.vue?vue&type=template&id=47875dcb&scoped=true"
import script from "./AgregarArchivoCuentaCobro.vue?vue&type=script&lang=js"
export * from "./AgregarArchivoCuentaCobro.vue?vue&type=script&lang=js"
import style0 from "./AgregarArchivoCuentaCobro.vue?vue&type=style&index=0&id=47875dcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47875dcb",
  null
  
)

export default component.exports